function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class MauthUser {
    get user() {
        return this._user;
    }
    setUser(user) {
        this._user = user;
    }
    isLogin() {
        return !!this.user;
    }
    constructor(){
        _define_property(this, "_user", void 0);
    }
}
